import FiltersProvider from 'providers/FiltersProvider';
import React from 'react';

import SubNavbar from '../SubNavbar';
import AgendaPopoverTrigger from './AgendaPopoverTrigger';
import FilterTags from './FilterTags';
import LocalSpeaksTrigger from './LocalSpeaksTrigger';
import MoreFiltersTrigger from './MoreFiltersTrigger';
import PeoplePopoverTrigger from './PeoplePopoverTrigger';

const CSS = require('./ExperienceFilterSubNavbar.module.scss');

function ExperienceFilterSubNavbar() {
  return (
    <SubNavbar>
      <FiltersProvider>
        {({ filters, adults, children }) => (
          <div className={CSS.Filters}>
            <AgendaPopoverTrigger filters={filters} />
            <PeoplePopoverTrigger
              adultsFilter={adults}
              childrenFilter={children}
            />
            <LocalSpeaksTrigger
              selectedLanguages={filters.activeFilters.find(
                (filter) => filter.uid === 'languages.items[]',
              )}
            />
            <MoreFiltersTrigger selectedFilters={filters.activeFilters} />
            <FilterTags activeFilters={filters.activeFilters} />
          </div>
        )}
      </FiltersProvider>
    </SubNavbar>
  );
}

export default ExperienceFilterSubNavbar;
